import React, { useEffect, useState } from "react";
import { Row, Form, Tab, Tabs, Col, Container, Collapse } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getApi } from "../../../../actions/structure.action";
import "./index.css";
import CustomTable from "../../common/CustomTable";
import { tableStructures } from "../../../../helpers/table-structures";
import isEmpty from "../../../../utils/is-Empty";
import CustomButton from "../../../common/CustomButton";
import { CloseIcon, ViewIcon } from "../../../../assets/svg/svg-icons";
import CustomModalWrap from "../../../common/CustomModalWrap";
import EnquiryDetails from "../../../Enquiry/EnquiryDetails";
import moment from "moment-timezone";

const AcceptedEnquiries = ({ enquiryStatus, title }) => {
  const dispatch = useDispatch();

  const { auth, enquiry } = useSelector((state) => state);
  const [acceptedEnquiries, setAcceptedEnquiries] = useState([]);
  const [currentEnquiryPkId, setCurrentEnquiryPkId] = useState("");
  const [showEnquiryModel, setEnquiryModal] = useState(false);
  const [isOpen, setIsOpen] = useState(true); // Collapsed/expanded state

  const enquiryViewToggle = () => setEnquiryModal(!showEnquiryModel);
  const EnquiryDetailsModal = () => {
    return (
      <CustomModalWrap
        className="modal-custom-class order-popup"
        hedaerContent={
          <>
            <h4>{"Enquiry"}</h4>
            <p
              onClick={() => {
                enquiryViewToggle();
              }}
            >
              <CloseIcon />
            </p>
          </>
        }
        buttonClasses={"action-button  hidden"}
        buttonContant={"view"}
        isModalOpen={showEnquiryModel}
        showModal={enquiryViewToggle}
        closeModal={enquiryViewToggle}
      >
        <EnquiryDetails
          id={currentEnquiryPkId}
          currentEnquiry={acceptedEnquiries.find((enq) => enq.enquiry_pk_id === currentEnquiryPkId)}
        />
      </CustomModalWrap>
    );
  };

  useEffect(() => {
    // Fetch enquiries logic can be added here
    getApi("getEnquiry", dispatch);
  }, []);

  useEffect(() => {
    if (!isEmpty(enquiry?.data?.enquiryDetails) && enquiry?.data?.enquiryDetails.length > 0) {
      let tempPendingEnquiries = enquiry?.data?.enquiryDetails.filter(
        (item) => item.enquiry_status === `${enquiryStatus}`
      );
      setAcceptedEnquiries(tempPendingEnquiries);
    }
  }, [enquiry, enquiryStatus]);

  return !isEmpty(acceptedEnquiries) && acceptedEnquiries.length > 0 ? (
    <Container className="px-2 no-records pb-0">
      {EnquiryDetailsModal()}
      <Row className="section-row mb-2 ">
        {/* Clickable header */}
        <Row
          className="mx-0 mb-2"
          style={{
            cursor: "pointer",
            borderBottom: "1px solid #ddd",
            padding: "0.5rem 0",
          }}
          onClick={() => setIsOpen(!isOpen)}
        >
          <Col xs="auto" className="flex-grow-1">
            <h4 className="m-0">{title}</h4>
          </Col>
          <Col xs="auto">
            <i
              className={`bi ${isOpen ? "bi-dash-lg" : "bi-plus-lg"}`}
              style={{ fontSize: "1.2rem" }}
            ></i>
          </Col>
        </Row>

        {/* Collapsible content */}
        <Collapse in={isOpen}>
          <div>
            <Row className="mb-2">
              <CustomTable
                enableRowActions
                data={acceptedEnquiries}
                enableTopToolbar={false}
                enableBottomToolbar={true}
                enablePagination={true}
                enableFilters={false}
                emptyTableMsg={`No ${enquiryStatus} enquiries found`}
                positionActionsColumn={"last"}
                muiTableBodyRowProps={({ row }) => {
                  const { enquiry_status, accepted_at } = row.original;

                  const todayDate = moment().tz("Asia/Kolkata").format("YYYY-MM-DD");
                  const acceptedDate = accepted_at
                    ? moment(accepted_at).tz("Asia/Kolkata").format("YYYY-MM-DD")
                    : null;

                  const highlight = enquiry_status === "accepted" && acceptedDate === todayDate;

                  return {
                    sx: {
                      backgroundColor: highlight ? "#e6ffe6 !important" : "inherit",
                      "& td": {
                        backgroundColor: highlight ? "#e6ffe6 !important" : "inherit",
                      },
                      "&:hover td": {
                        backgroundColor: highlight ? "#d4fcd4 !important" : "rgba(0, 0, 0, 0.04)", // MUI default hover
                      },
                    },
                  };
                }}
                columns={(() => {
                  if (enquiryStatus === "accepted") {
                    return tableStructures.accepted_enquiries;
                  } else {
                    return tableStructures.pending_enquiries;
                  }
                })()}
                initialState={{
                  columnPinning: {
                    right: ["mrt-row-actions"],
                  },
                }}
                renderTopToolbarCustomActions={({ table }) => (
                  <Row style={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}>
                    <h4>{title}</h4>
                  </Row>
                )}
                renderRowActions={({ row, table }) => (
                  <div className="table-action-box">
                    <CustomButton
                      buttonClasses="action-button"
                      id={row.original.enquiry_pk_id}
                      onClick={() => {
                        // Logic to view enquiry details can be added here
                        setCurrentEnquiryPkId(row.original.enquiry_pk_id);
                        enquiryViewToggle();
                      }}
                    >
                      <ViewIcon />
                    </CustomButton>
                  </div>
                )}
              />
            </Row>
          </div>
        </Collapse>
      </Row>
    </Container>
  ) : (
    <Container className="no-records pb-4">
      <h4 className="title">{title}</h4>
      <p>{`No ${enquiryStatus} enquiries found`}</p>
    </Container>
  );
};

export default AcceptedEnquiries;
